export default "__VITE_ASSET__5f3079b7__"